export function doAjax(url, method="POST", options={})
{
  return (dispatch, getState) => {
    const id = getState().async_n+1;
    dispatch({type: "LOADING", id: id});

    fetch(url, {method: method, credentials: "same-origin", body: options.body})
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
          }
        return response;
      })
      .then((response) => {return response.json();})
      .then((x) => {
        dispatch({type: "LOADED", id: id}); // TODO: deberia ir en el finally
        if (x.redirect) {
          window.location = x.redirect;
        } else if (x.mustlogin) {
          dispatch({type: "STATUS_SET", v: {login: true, after_login: [url,method], usuario: {}} })
        } else {
          if (options.callback) {
            options.callback(x, dispatch, getState);
          } else {
            dispatch({type: "STATUS_SET", v: x})
            }
          }
      })
      .catch((x) => { dispatch({type: "ERROR", v: url+": "+ x.toString()});
                      dispatch({type: "LOADED", id: id});
                    });
/*      .finally(() => dispatch({type: "LOADED", id: id})); */ /* da error en el kiosko */
    }
}

export function array2hash(a) {
  return a.reduce((m, u) => {m[u[0]] = u[1];return m;}, {})
}
